import React from 'react';
import { Card, CardBody, CardImg, CardText, Badge, Spinner } from 'reactstrap';

const FaceCard = ({ detection, loading, handleImageClick }) => {
  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr);
    return date.toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });
  };


  return loading ? (
    <div className="d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
      <Spinner style={{ width: '2.5rem', height: '2.5rem', color: '#1e67d6' }} />
    </div>
  ) : (
    <Card className="mb-2 face-detection-card">
      <img
        top
        src={detection?.face_image_url}
        alt={`Face of ${detection.employee_name}`}
        className="face-image"
        onClick={() => handleImageClick(detection?.face_image_url)}
      />
      <CardBody className='p-2'>
        <div className="d-flex justify-content-between align-items-center mb-2">
          <small className="text-muted fw-bold">{detection.employee_name}</small>
          <Badge
            color={detection.blacklisted ? "danger" : "primary"}
            pill
          >
            {detection.blacklisted ? "Blacklisted" : detection.employee_designation}
          </Badge>
        </div>
        <CardText className="mb-0">
          <small className="text-muted">ID: {detection.employee_id}</small>
        </CardText>
        <CardText className="mb-0">
          <small className="text-muted">Camera: {detection.camera_name}</small>
        </CardText>
        <CardText className="mb-0">
          <small className="text-muted">Position: {detection.camera_position_no}</small>
        </CardText>
        <CardText className="mb-0">
          <small className="text-muted">Time: {formatDateTime(detection.detection_datetime)}</small>
        </CardText>
        <CardText className="mb-0">
          <Badge
            color={detection.sop_followed ? "success" : "warning"}
            pill
          >
            {detection.sop_followed ? "SOP Followed" : "SOP Not Followed"}
          </Badge>
        </CardText>
      </CardBody>
    </Card>
  );
};

export default FaceCard;